const HTMLElementBase = globalThis.HTMLElement ?? class {};

export class PbGuarantee extends HTMLElementBase {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.openButton = this.querySelector("[data-pb-guarantee-open]");
    this.closeButton = this.querySelector("[data-pb-guarantee-close]");
    this.dialog = this.querySelector("dialog");

    if (!this.openButton || !this.closeButton || !this.dialog) return;

    this.openButton.addEventListener("click", () => this.open());
    this.closeButton.addEventListener("click", () => this.dialog.close());
    this.dialog.addEventListener("click", (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener("close", () => {
      if (Math.abs(window.scrollY - this.scrollPosition) > 1) {
        window.scrollTo(0, this.scrollPosition);
      }
      this.openButton.focus({ preventScroll: true });
    });
  }

  open() {
    this.scrollPosition = window.scrollY;
    this.dialog.showModal();
  }
}

if (typeof window !== "undefined" && !window.customElements.get("pb-guarantee")) {
  window.customElements.define("pb-guarantee", PbGuarantee);
}

function initializeCookingVideos() {
  const videos = document.querySelectorAll("[data-pb-cooking-video]");

  if (!("IntersectionObserver" in window)) {
    videos.forEach((video) => video.play().catch(() => {}));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.play().catch(() => {});
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "200px 0px" },
  );

  videos.forEach((video) => observer.observe(video));
}

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCookingVideos, { once: true });
  } else {
    initializeCookingVideos();
  }
}
